import validators from '@utils/validators';
import {EXTERNAL_DESCRIPTION_LIMIT} from '@constants/variables';

export const validate = (values) => {
    const errors = {};

    Object.assign(errors, validators.required(values.property_licence, 'property_licence'));
    Object.assign(errors, validators.dateTime(values.start_datetime, 'start_datetime'));
    Object.assign(errors, validators.dateTime(values.end_datetime, 'end_datetime'));
    Object.assign(errors, validators.required(values.event_status, 'event_status'));
    Object.assign(errors, validators.startDateBeforeEndDate({
        startDate: values.start_datetime,
        endDate: values.end_datetime,
    }, 'end_datetime'));

    Object.assign(errors, validators.maxLength(
        {value: values.external_description, maxLength: EXTERNAL_DESCRIPTION_LIMIT}, 'external_description')
    );

    if (values.preset_save) {
        Object.assign(errors, validators.required(values.preset_name, 'preset_name'));
    }

    return errors;
};
